import GeneralTranslations from "../../../Common/ModuleTranslations/fr";

export default {
  locale: "fr",
  name: "Bookable",
  translation: { displayName: "Traductions" },
  fields: {
    list: [
      ...GeneralTranslations.fields.list,
      {
        fieldName: "arrangement",
        displayName: "Ordre",
      },
      {
        fieldName: "isActive",
        displayName: "Actif",
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
      },
      {
        fieldName: "name",
        displayName: "Nom",
      },
      {
        fieldName: "rate",
        displayName: "Typologie",
      },
      {
        fieldName: "type",
        displayName: "Utilisation",
      },
    ],
    form: [
      ...GeneralTranslations.fields.form,
      {
        fieldName: "isActive",
        displayName: "Actif",
      },
      {
        fieldName: "isVisible",
        displayName: "Visible",
      },
      {
        fieldName: "name",
        displayName: "Nom",
      },
      {
        fieldName: "description",
        displayName: "Description",
      },
      {
        fieldName: "codesSection",
        displayName: "Code entreprise",
        subtitle:
          "Seuls les utilisateurs qui saisissent ce code dans le moteur de réservation peuvent activer cette promotion",
      },
    ],
  },
};
